var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSavings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 15C20.7147 15 19.6019 15.4609 18.7814 16.2814C17.9609 17.1019 17.5 18.2147 17.5 19.375C17.5 20.5353 17.9609 21.6481 18.7814 22.4686C19.6019 23.2891 20.7147 23.75 21.875 23.75H30V30H0V8.75H30V15H21.875ZM23.125 21.25H21.875C21.3777 21.25 20.9008 21.0525 20.5492 20.7008C20.1975 20.3492 20 19.8723 20 19.375C20 18.8777 20.1975 18.4008 20.5492 18.0492C20.9008 17.6975 21.3777 17.5 21.875 17.5H23.125C23.6223 17.5 24.0992 17.6975 24.4508 18.0492C24.8025 18.4008 25 18.8777 25 19.375C25 19.8723 24.8025 20.3492 24.4508 20.7008C24.0992 21.0525 23.6223 21.25 23.125 21.25ZM20 0L25 6.25H10L20 0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavings);
export default __webpack_public_path__ + "static/media/savings.c7b7aed99f55426b13cb5f9fa3585178.svg";
export { ForwardRef as ReactComponent };